module.exports = __webpack_public_path__ + "static/img/newanli-10.d8cdb0e2.jpg";